exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-81ca93f4]{font-size:16px}h1[data-v-81ca93f4]{font-size:30px;text-align:center;padding:5px 0}h2[data-v-81ca93f4]{font-size:24px;text-align:center;padding:5px 0}td[data-v-81ca93f4],th[data-v-81ca93f4]{padding:8px;text-align:left}table[data-v-81ca93f4]{border:1px solid #000}td[data-v-81ca93f4],th[data-v-81ca93f4]{border-right:1px solid #000;border-bottom:1px solid #000}tr:last-child td[data-v-81ca93f4]{border-bottom:none}td[data-v-81ca93f4]:last-child,th[data-v-81ca93f4]:last-child{border-right:none}tr[data-v-81ca93f4]:last-child{border-bottom:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-81ca93f4","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/print/stockBills.vue
// module id = zXdf
// module chunks = 0